import React from 'react';
import { Typography } from '@mui/material';
import { titleCase } from 'title-case';

interface SnapshotApproachTitleProps {
  direction: string;
}

const SnapshotApproachTitle: React.FC<SnapshotApproachTitleProps> = ({
  direction,
}) => {
  return (
    <Typography variant="body2" gutterBottom fontStyle="italic">
      {titleCase(direction)}
    </Typography>
  );
};

export default SnapshotApproachTitle;
